import BaseController from "controllers/base"
import { placesUri }  from "servos/googlePlaces"

import ProposalBuilderWidget from "widgets/proposalBuilderWidget"

class Controller extends BaseController {
  call() {
    bindProposalBuilderWidget.call(this)
  }

  scripts() {
    return [placesUri]
  }
};

var bindProposalBuilderWidget = function() {
  let elem = this.root
  this.proposalBuilderWidget = new ProposalBuilderWidget(elem)
  this.proposalBuilderWidget.setState()
}

export default Controller;
